<template>
  <card headless>
    <template #body>
      <div>
        <div class="d-flex align-items-center">
          <h4 class="mb-0">
            <archived-label :disabled="!componentType.archived">
              {{ componentType.name }}
            </archived-label>
          </h4>
          <sera-button
            icon="fas fa-edit"
            class="edit-icon ml-2"
            @click="toggleModal"
          />
        </div>

        <div class="my-2">
          <b>Description: </b> {{ componentType.description || "--" }}
        </div>
        <div>
          <b>Included in: </b>
          <a
            v-if="Boolean(equipmentTypesCount)"
            href="#"
            @click.prevent="linkToEquipmentTypes"
          >
            ({{ equipmentTypesCount }}) Equipment Types
          </a>
          <span v-else>--</span>
        </div>
        <component-type-modal
          v-if="modalOpen"
          :component-type="componentType"
          @hide-modal="toggleModal"
        />
      </div>
    </template>
  </card>
</template>

<script>
import { EventBus } from "@/lib/event_bus.js";

import SeraButton from "@/components/Button.vue";
import Card from "@/components/Card.vue";
import ComponentTypeModal from "@/ComponentTypes/ComponentTypeModal.vue";
import { updateQueryParam } from "../lib/url.js";

export default {
  components: {
    Card,
    ComponentTypeModal,
    SeraButton
  },
  props: {
    componentType: {
      type: Object,
      default: null
    }
  },
  emits: ["set-selected-tab"],
  data() {
    return {
      collapsed: false,
      modalOpen: false
    };
  },
  computed: {
    equipmentTypesCount() {
      if (!this.componentType) {
        return 0;
      }
      return this.componentType.included_in.equipment_types.length;
    }
  },
  methods: {
    toggleModal() {
      this.modalOpen = !this.modalOpen;
    },
    async linkToEquipmentTypes() {
      // update query param
      await updateQueryParam("component_type_ids", [this.componentType.id]);
      // emit tab change event
      EventBus.$emit("set-selected-tab", "Equipment Types");
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-icon,
.arrow-icon {
  font-size: 1.2em;
}
</style>
